/*
 * @Description: 租户管理--租户模块配置
 * @Author: zhaoqing
 * @LastEditors  : pu.yuchun
 * @Date: 2019-07-17 15:04:10
 * @LastEditTime : 2019-12-27 17:31:56
 */
'use strict';
angular.module('moduleSettingModule', []).controller('moduleSettingCtrl', [
    '$scope',
    'trsspliceString',
    '$q',
    '$filter',
    'tManageMentService',
    'modalDialog',
    'trsHttpService',
    'permissionAssignmentService',
    function($scope, trsspliceString, $q, $filter, tManageMentService, modalDialog, trsHttpService, permissionAssignmentService) {
        // token 和租户 id
        var token = '',
            tenantId = '';

        $scope.treeData = [];
        // tree 组件配置
        $scope.treeOptions = {
            nodeChildren: 'childList',
            dirSelectable: true,
            allowDeselect: false,
            injectClasses: {
                ul: 'a1 manage-tree',
                li: 'a2',
                liSelected: 'a7',
                iExpanded: 'icon-previewright a3',
                iCollapsed: 'icon-previewright a4',
                iLeaf: 'a5',
                label: 'a6',
                labelSelected: 'rolegrouplabselected'
            },
            isLeaf: function(node) {
                return !node.childList || !node.childList.length;
            }
        };
        $scope.currNode = {}; //当前选中的节点
        // 给 tree 增加属性 ids: 所有父节点的id，path: 当前节点的路径/索引
        function addIdAndPath(arr, ids, path) {
            return arr.map(function(item, index) {
                item.ids = (ids || []).concat([item.moduleId]);
                item.path = (path || []).concat([index]);
                item.childList = item.childList ? addIdAndPath(item.childList, item.ids, item.path) : [];
                return item;
            });
        }

        // 获取树节点
        function getTreeData() {
            $scope.loadingPromise = trsHttpService
                .httpServer(
                    '/api/tenantcenter/moduleConfig/getModuleList',
                    {},
                    'get',
                    '',

                    { token: token }
                )
                .then(function(data) {
                    if (data.code !== '200') return;
                    // 请求被勾选的树节点
                    getModuleTree(data.datas);
                });
        }

        // 获取当前登录人的信息 获取token
        function getCurrentInfo() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'getCurrUserInfo'
            };
            $scope.loadingPromise = trsHttpService
                .httpServer(trsHttpService.getWCMRootUrl(), params, 'get', '', {
                    token: token
                })
                .then(function(data) {
                    if (data.TENANTID) {
                        tenantId = data.TENANTID;
                        getToken(deffer.resolve);
                    }
                });
            return deffer.promise;
        }

        // 获取token
        function getToken(resolve) {
            var params = {
                serviceid: 'getToken',
                tenantId: tenantId
            };
            $scope.loadingPromise = trsHttpService
                .httpServer(trsHttpService.getWCMRootUrl(), params, 'get', '', {
                    token: token
                })
                .then(function(data) {
                    if (data.token) {
                        token = data.token;
                        resolve();
                    }
                });
        }

        // 获取 token 后 ，请求树节点
        getCurrentInfo().then(function() {
            getTreeData();
        });

        // 获取已经被选择的tree
        function getModuleTree(treeData) {
            var params = {
                tenantId: tenantId
            };
            $scope.loadingPromise = trsHttpService.httpServer('/api/tenantcenter/module/getModuleTree', params, 'get', '', { token: token }).then(function(data) {
                if (includes(['200', '500'], data.code)) {
                    // 处理 treeData，增加父节点id（ids），增加路径索引（path），修改节点的选择状态
                    $scope.treeData = addIdAndPath(treeData);
                    if (!data.datas) return;
                    // 获取被选择的节点 id
                    var ids = [];
                    traverse(data.datas, function(item) {
                        ids.push(item.moduleId);
                    });
                    traverse(treeData, function(item) {
                        var isAll = true;
                        traverse(item.childList, function(v) {
                            if (!includes(ids, v.moduleId)) isAll = false;
                        });
                        var selectAll = item.childList.length === 0 || (item.childList.length && isAll);
                        if (includes(ids, item.moduleId) && selectAll) item.checked = true;
                    });
                }
            });
        }

        // 通过path获取节点
        function getNode(path) {
            var pathStr = path.reduce(function(cur, next) {
                return cur + (cur ? '.childList' : '') + '[' + next + ']';
            }, '');
            return eval('$scope.treeData' + pathStr);
        }

        // 选择所有
        function initSelectAll(path, checked) {
            var obj = getNode(path);
            obj.childList.forEach(function(item) {
                angular.isArray(item.childList) && initSelectAll(item.path, checked);
                item.checked = checked;
            });
        }

        // 选择节点
        $scope.checkNode = function(path) {
            var obj = getNode(path);
            obj.checked = !obj.checked;
            if (obj.checked) {
                $scope.currNode = angular.copy(obj);
            }
            // 向下设置子级选中状态
            obj.childList && initSelectAll(path, obj.checked);
            // 向上设置父级选中状态
            path.forEach(function(item, index) {
                var obj = getNode(path.slice(0, -1 - index));
                // 向上找到顶层，直接返回
                if (angular.isArray(obj)) return;
                obj.checked = obj.childList.every(function(v) {
                    return v.checked;
                });
            });
        };

        // 保存
        $scope.saveAll = function() {
            if (!$scope.treeData.length) return;
            var ids = [];
            traverse($scope.treeData, function(item) {
                if (item.checked) ids = ids.concat(item.ids);
            });

            var params = {
                moduleIds: removeDuplicates(ids).join(','),
                tenantId: tenantId
            };

            trsHttpService.httpServer('/api/tenantcenter/moduleConfig/bindModules', params, 'post', '', { token: token }).then(function(data) {
                if (data.code === '200') {
                    modalDialog.saveModel('提示', '保存成功', 'success', false);
                    // getTreeData();
                } else {
                    modalDialog.alertType('提示', data.msg || '保存失败', 'error', 'confirm', function() {});
                }
            });
        };
        /**
         * @description: 显示模块详情
         * @param {type}
         * @return:
         */
        $scope.showDetail = function(path) {
            var obj = getNode(path);
            $scope.currNode = angular.copy(obj);
            var params = { moduleId: obj.moduleId, tenantId: tenantId };
            trsHttpService.httpServer('/api/tenantcenter/moduleConfig/findModuleRegion', params, 'get', '', { token: token }).then(function(data) {
                $scope.currNode.region = data.datas;
            });
        };
        /**
         * @description: 地域绑定
         * @param {type}
         * @return:
         */
        $scope.bindArea = function() {
            // 提示必须先绑定模块
            if (!$scope.currNode.checked) {
                modalDialog.alertType('需要绑定该模块才能绑定对应地域！', '', 'warning', false);
                return;
            }
            tManageMentService.bindRegion($scope.currNode.moduleId).then(function() {
                $scope.showDetail($scope.currNode.path);
            });
        };

        // 递归遍历
        function traverse(arr, fn) {
            arr.forEach(function(item) {
                fn(item);
                item.childList && traverse(item.childList, fn);
            });
        }

        // 数组去重
        function removeDuplicates(arr) {
            return arr.filter(function(v, i) {
                return arr.indexOf(v) === i;
            });
        }

        // includes
        function includes(arr, item) {
            return arr.indexOf(item) !== -1;
        }

        return false;
    }
]);
